import React from 'react';
import PropTypes from 'prop-types';
import { makeFullAddressDisplay } from '@utilityprofit/address-helpers';
import { formatPhoneNumber } from 'common/formatters';
import { hasRoleAdmin } from 'common/utility/userRoles';
import { getEntityOwnershipText } from 'common/utility/helpers';

import SrBox from 'client/components/SrBox';
import SrLink from 'client/components/SrLink/SrLink';
import SrLinkUrlButton from 'client/components/SrLinkUrlButton';

import './SrUtilityActivationStatusModalHeader.less';

const MODAL_LINK_URL = 'https://utility-setup.com';

const getModalTitle = (user) => {
  if (!user) {
    return "Tenant's Utilities";
  }
  return getEntityOwnershipText({ name: user.firstName, word: 'Utilities' });
};

const SrUtilityActivationStatusModalHeader = ({ activation, utilityUser }) => {
  const isAdminUser = hasRoleAdmin(utilityUser.roles);

  return (
    <div styleName="SrUtilityActivationStatusModalHeader">
      <div styleName="title">{getModalTitle(activation.user)}</div>
      {activation.user && (
        <div styleName="userInfo">
          {formatPhoneNumber(activation.user.phone)} {' - '}
          {activation.user.email}
        </div>
      )}
      <div styleName="address" display="block">
        {makeFullAddressDisplay(activation.address)}
      </div>
      {isAdminUser && (
        <SrBox styleName="adminLinks">
          <SrLink to={`/utility-profit/admin/processing/${activation.shortId}`} target="_blank">
            <div styleName="link">Go to Utility Processing Tool</div>
          </SrLink>
          <SrLink
            to={`/utility-setup/${activation.partner.slug}/${activation.shortId}`}
            target="_blank"
          >
            <div styleName="link">Go to Renter Activation Page</div>
          </SrLink>
          <SrBox>
            <SrLinkUrlButton
              buttonText="Copy Renter Utility Link"
              className="utilityActivationLink modalLink"
              hideUrl
              href={`${MODAL_LINK_URL}/${activation.partner.slug}/${activation.shortId}`}
            />
          </SrBox>
        </SrBox>
      )}
    </div>
  );
};

SrUtilityActivationStatusModalHeader.propTypes = {
  activation: PropTypes.shape({
    user: PropTypes.shape({
      firstName: PropTypes.string,
      phone: PropTypes.string,
      email: PropTypes.string,
    }),
    address: PropTypes.object.isRequired,
    shortId: PropTypes.string.isRequired,
    partner: PropTypes.shape({
      slug: PropTypes.string.isRequired,
    }).isRequired,
  }).isRequired,
  utilityUser: PropTypes.shape({
    roles: PropTypes.arrayOf(PropTypes.string).isRequired,
  }).isRequired,
};

export default SrUtilityActivationStatusModalHeader;
